// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"2162": "50116afa","2530": "e96a97f9","4424": "b6607098","8561": "f9cad78a",}[chunkId] + ".css"
}